import { FC, memo } from 'react';
import { useResponsive } from '../../../../hooks';
import { Skeleton } from '../../components-v4';

export const BannerSkeleton: FC = memo(() => {
  const { viewport } = useResponsive();

  return <Skeleton width={'100%'} height={viewport.mobile ? '60px' : '80px'} />;
});
